import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Event, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { IntercomService } from "@teammood/shared/util/intercom";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterOutlet
    ]
})
export class AppComponent {
  title = 'teammood';

  constructor(private router: Router, private intercomService: IntercomService) {

    // Subscribe to router events and react to events
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        intercomService.update();
      }
    });
  }
}
